import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SemPermissaoComponent } from './sem-permissao/sem-permissao.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AvisoComponent } from './aviso/aviso-component';
import {CodexAuthGuard} from './guard/codex-auth.guard';
import { AplicacaoDadosComponent } from './aplicacao/aplicacao-dados/aplicacao-dados.component';

const routes: Routes = [
  { path: '', component: DashboardComponent , canActivate: [CodexAuthGuard] },
  { path: 'semPermissao', component: SemPermissaoComponent },
  { path: 'aviso' , component: AvisoComponent},
  { path: 'aplicacao', component: AplicacaoDadosComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
